// One source of truth for the questions: the visible list and the FAQPage
// structured data are rendered from the same array, and only on the page
// that shows them.
export const FAQ: { q: string; a: string }[] = [
  {
    q: 'How do I collect anonymous feedback on a meeting?',
    a: 'Invite bot@calendarfeedback.com as an attendee on the calendar event. That is the whole setup. Fifteen minutes after the meeting ends, up to ten accepted attendees get an email with thumbs up, neutral and thumbs down. No forms to build, no app to install, nothing to remember during the meeting.',
  },
  {
    q: 'How is a meeting scored?',
    a: 'Votes are averaged into one 0 to 100 score, shared with the organiser and everyone who voted two hours after the meeting. One number per meeting is deliberate. It is comparable across weeks, so a recurring meeting that drifts from 80 to 55 tells you something nobody would say out loud.',
  },
  {
    q: 'Is it really anonymous?',
    a: 'Anonymous by design, not by policy. Attendee addresses are stored only as one-way hashes, a vote is stored against the meeting rather than the person, no score is produced until at least three people vote, and organisers only ever see the aggregate.',
  },
  {
    q: 'Does it work with Outlook or Microsoft Teams?',
    a: 'Not yet. Google Calendar only for now, with Microsoft 365 on the roadmap. If your meeting lives in Google Calendar but runs on Zoom, Meet or Teams, that is fine: the bot reads the calendar invite and accepts it, nothing else.',
  },
  {
    q: 'What does it cost?',
    a: 'Nothing. Surveys go to at most ten accepted attendees per meeting, at least three accepted attendees are needed before any survey goes out, and every email carries a permanent one-click unsubscribe.',
  },
]

export function Faq() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQ.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  }
  return (
    <section className="wrap section" aria-labelledby="faq-title">
      <h2 id="faq-title">Questions</h2>
      <div className="faq">
        {FAQ.map(({ q, a }) => (
          <div className="faq-item" key={q}>
            <h3>{q}</h3>
            <p>{a}</p>
          </div>
        ))}
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    </section>
  )
}
